(function() { window.GUID_cb32a1d5_0578_4231_ad2b_e8eb9a254228 = { getGuid: function() { return "cb32a1d5-0578-4231-ad2b-e8eb9a254228"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let OrderDirection;
        (function (OrderDirection) {
            OrderDirection[OrderDirection["Ascending"] = 0] = "Ascending";
            OrderDirection[OrderDirection["Descending"] = 1] = "Descending";
        })(OrderDirection = Enumeration.OrderDirection || (Enumeration.OrderDirection = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=OrderDirection.pre.js.map
